import { Door, Location, Query } from 'graphql/generated/graphqlTypes';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { generateMockLocation } from 'mocks/graphqlMocks/location';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { mockedGetDoorsForTenantDataAdmin } from './getDoorsForTenant';

const testGroup1Doors = mockedGetDoorsForTenantDataAdmin.getDoorsForTenant.filter((door) =>
  door.locationIds.includes('TestGroup1')
);
const testGroup2Doors = mockedGetDoorsForTenantDataAdmin.getDoorsForTenant.filter((door) =>
  door.locationIds.includes('TestGroup2')
);
const testGroup3Doors = mockedGetDoorsForTenantDataAdmin.getDoorsForTenant.filter((door) =>
  door.locationIds.includes('TestGroup3')
);

export function mockedGetLocationWithDoorsForTenantData(
  getLocationsForTenant: Array<Location>
): Pick<Query, 'getLocationsForTenant'> {
  return {
    getLocationsForTenant
  };
}

const fieldsToRemove: (keyof Location)[] = ['doorIds'];
const doorFieldsToRemove: (keyof Door)[] = ['locationIds', 'locations', 'officeMode', 'taReaderId', 'supportsOssCards'];

export const mockedGetLocationWithDoorsForTenantDataUnitTests = mockedGetLocationWithDoorsForTenantData([
  removeFields(
    generateMockLocation({
      id: 'mockedLocationId0',
      name: 'lock group 0 (without doors)'
    }),
    fieldsToRemove
  ),
  removeFields(
    generateMockLocation({
      id: 'mockedLocationId1',
      name: 'lock group 1',
      doors: [removeFields(generateMockDoor({ id: 'mockedDoorId10' }), doorFieldsToRemove)]
    }),
    fieldsToRemove
  ),
  removeFields(
    generateMockLocation({
      id: 'mockedLocationId2',
      name: 'lock group 2(all doors assigned)',
      doors: [
        removeFields(generateMockDoor({ id: 'mockedDoorId10' }), doorFieldsToRemove),
        removeFields(generateMockDoor({ id: 'mockedDoorId11' }), doorFieldsToRemove),
        removeFields(generateMockDoor({ id: 'mockedDoorId12' }), doorFieldsToRemove)
      ]
    }),
    fieldsToRemove
  )
]);

export const mockedGetLocationWithDoorsForTenantDataAdmin = mockedGetLocationWithDoorsForTenantData([
  generateMockLocation({
    id: 'TestGroup1',
    name: 'Test group 1',
    doors: testGroup1Doors,
    doorIds: testGroup1Doors.map((door) => door.id)
  }),
  generateMockLocation({
    id: 'TestGroup2',
    name: 'Test group 2',
    doors: testGroup2Doors,
    doorIds: testGroup2Doors.map((door) => door.id)
  }),
  generateMockLocation({
    id: 'TestGroup3',
    name: 'Test group 3',
    doors: [],
    doorIds: []
  })
]);

export const mockedGetDeviceGroupDetailDoorsDataAdmin = mockedGetLocationWithDoorsForTenantData([
  generateMockLocation({
    id: 'TestGroup1',
    name: 'Test group 1',
    doors: testGroup1Doors,
    doorIds: testGroup1Doors.map((door) => door.id)
  }),
  generateMockLocation({
    id: 'TestGroup2',
    name: 'Test group 2',
    doors: testGroup2Doors,
    doorIds: testGroup2Doors.map((door) => door.id)
  }),
  generateMockLocation({
    id: 'TestGroup3',
    name: 'Test group 3',
    doors: testGroup3Doors,
    doorIds: testGroup3Doors.map((door) => door.id)
  })
]);
